import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, map } from "lodash";

import Grid from "@material-ui/core/Grid";

import DashboardCard from "../DashboardCard";

import { displayData } from "../../../utils/data";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const MdcOnSites = (props) => {
  const { data } = props;

  const vehicleTypes = [
    {
      id: "trucks",
      name: I18n.get("dashboard_trucks"),
      icon: images.truckIconDarkGrey,
    },
    {
      id: "trailers_containers",
      name: `${I18n.get("dashboard_trailers")} / ${I18n.get(
        "dashboard_containers"
      )}`,
      icon: images.containerTrailerIcon,
    },
    {
      id: "private_vehicles",
      name: I18n.get("dashboard_privateVehicles"),
      icon: images.carIconGrey,
    },
  ];

  return (
    <DashboardCard
      title={I18n.get("dashboard_onSites")}
      //size={625}
      style={{
        margin: "12px",
        minWidth: "625px",
        flexGrow: 3,
      }}
    >
      <Grid
        container
        justify="space-evenly"
        alignItems="center"
        style={{ height: "100%" }}
      >
        {map(vehicleTypes, (type) => (
          <Grid item xs key={type.id}>
            <Grid container direction="column">
              <Grid item className="text-center text-87 bold-500">
                {get(type, ["name"])}
              </Grid>
              <Grid
                item
                className="flexCenter"
                style={{ justifyContent: "center", height: "50px" }}
              >
                <img
                  src={get(type, ["icon"])}
                  alt={type.id}
                  style={{ height: "40px" }}
                />
              </Grid>
              <Grid
                item
                style={{
                  fontWeight: 500,
                  fontSize: "2em",
                  lineHeight: "30px",
                  //color: colors.primary,
                  color: colors.black87,
                  textAlign: "center",
                  marginTop: "10px",
                }}
              >
                {displayData(get(data, ["card2", type.id]))}
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </DashboardCard>
  );
};

export default MdcOnSites;
